import { usePlayerStore } from "@/features/player-management/stores/usePlayerStore";
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "./ui/card";
import { pocketbase } from "@/services/pocketbase";

export function Lobby(props: {
  roomId: string;
  onStartGame?: () => void;
}) {
  const { roomId, onStartGame } = props;
  const players = usePlayerStore((state) => state.players);

  return (
    <Card className="max-w-md w-full h-[500px]">
      <CardHeader>
        <CardTitle className="text-2xl font-bold">Lobby</CardTitle>
        <CardDescription>{roomId}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col h-full">
        <h3 className="text-lg font-semibold mb-4">Players</h3>
        <div className="flex-1">
          <ul className="space-y-2">
            {players.map((player) => (
              <li key={player.id} className="flex items-center justify-between p-2 border-b">
                <div className="flex items-center">
                  <img src={pocketbase().files.getURL({collectionName: 'users', id: player.id}, player.avatar ?? "")} alt={player.name} className="w-8 h-8 rounded-full mr-2" />
                  <span>{player.name}</span>
                </div>
                <span className="text-sm text-gray-500">{player.id}</span>
              </li>
            ))}
          </ul>
        </div>

        <Button onClick={() => onStartGame?.()} size={"lg"} className="w-full">
          Start Game
        </Button>
      </CardContent>
      <CardFooter>

      </CardFooter>
    </Card>
  );
}
